import { trpc } from "@/trpc";
import { useWizard } from "./WizardContext";

export function Step2Waiver() {
  const { state, dispatch } = useWizard();
  const waiver = trpc.eventRegistration.getCurrentWaiver.useQuery();

  return (
    <div className="space-y-4">
      <div className="rounded-md border p-4 space-y-3">
        <p className="text-sm font-medium">Waiver</p>
        {waiver.data && (
          <div className="rounded border border-border bg-muted/50 p-3 text-xs text-muted-foreground leading-relaxed whitespace-pre-wrap max-h-64 overflow-y-auto">
            {waiver.data.body}
          </div>
        )}
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="checkbox"
            checked={state.waiverSigned}
            onChange={(e) => dispatch({ type: "SET_WAIVER_SIGNED", signed: e.target.checked })}
            className="rounded border-border"
          />
          I accept the waiver
        </label>
      </div>
    </div>
  );
}
